import {useTheme, styled} from '@mui/material/styles';
import {Fragment, useEffect, useState} from "react"
import {
    Avatar,
    Button,
    Card,
    CardContent,
    Chip,
    Divider, Fade,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Stack,
    Typography
} from '@mui/material';
import {IconBrandTelegram, IconBuildingStore, IconMailbox, IconPhoto} from '@tabler/icons-react';
import User1 from 'assets/images/users/user-round.svg';
import {CheckRounded, CloseRounded, InfoRounded, WarningRounded} from "@mui/icons-material";
import moment from "moment/moment";
import PropTypes from "prop-types";
import InventoryTagInfo from "../../../../views/pages/inventory/components/InventoryTagInfo/InventoryTagInfo";
import Lottie from "lottie-react";
import emptyBoxAnimation from "../../../../assets/animations/empty-box-animation.json";
import * as React from "react";
import dayjs from 'dayjs';

// styles
const ListItemWrapper = styled('div')(({theme}) => ({
    cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const NotificationList = (props) => {
    const theme = useTheme();

    const [notifications, setNotifications] = useState([])

    useEffect(() => {
        setNotifications(props.data)
    }, [props]);


    const chipSX = {
        height: 24,
        padding: '0 6px'
    };
    const chipErrorSX = {
        ...chipSX,
        color: theme.palette.orange.dark,
        backgroundColor: theme.palette.orange.light,
        marginRight: '5px'
    };

    const chipWarningSX = {
        ...chipSX,
        color: theme.palette.warning.dark,
        backgroundColor: theme.palette.warning.light
    };

    const chipSuccessSX = {
        ...chipSX,
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.success.light,
        height: 28
    };



    const getNotificationIcon = (notificationType) => {
        let icon = (<InfoRounded/>);
        let bgColor = theme.palette.info.light;

        switch (notificationType) {
            case 'error':
                icon = <CloseRounded/>;
                bgColor = theme.palette.error.main;
                break;
            case 'success':
                icon = <CheckRounded/>;
                bgColor = theme.palette.success.main;
                break;
            case 'success':
                icon = <WarningRounded/>;
                bgColor = theme.palette.warning.light;
                break;
            default:
                // do nothing
                break;
        }

        return (
            <Avatar sx={{bgcolor: bgColor, color: '#fff', width: 30, height: 30}}>
                {icon}
            </Avatar>
        )
    }

    return (
        <List
            sx={{
                width: '100%',
                // maxWidth: 330,
                py: 0,
                borderRadius: '10px',
                [theme.breakpoints.down('md')]: {
                    maxWidth: 370
                },
                '& .MuiListItemSecondaryAction-root': {
                    // top: 22
                },
                '& .MuiDivider-root': {
                    my: 0
                },
                '& .list-container': {
                    pl: 7
                }
            }}
        >
            {notifications.map((notification) => {
                return (
                    <Fragment>
                        <ListItemWrapper >
                            <ListItem alignItems="center" key={notification.id}>
                                <ListItemAvatar>
                                    {getNotificationIcon(notification.type)}
                                </ListItemAvatar>
                                <ListItemText primary={notification.title}/>
                                <ListItemSecondaryAction>
                                    <Typography variant="caption">
                                        {dayjs(notification.created_at).format('DD/MM/YYYY HH:mm:ss')}
                                    </Typography>
                                </ListItemSecondaryAction>
                            </ListItem>
                            <Grid container direction="column" className="list-container">
                                <Grid item xs={12} sx={{pb: 2, pt: 1}}>
                                    <Typography variant="subtitle2">{notification.message}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Fade in={!notification.readed} mountOnEnter unmountOnExit>
                                            <Grid item>
                                                <Chip label="No leída" sx={chipErrorSX}/>
                                            </Grid>
                                        </Fade>
                                        <Fade in={!notification.readed} mountOnEnter unmountOnExit>
                                            <Grid item>
                                                <Chip label="New" sx={chipWarningSX}/>
                                            </Grid>
                                        </Fade>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ListItemWrapper>
                        <Divider variant={"middle"}/>
                    </Fragment>
                );
            })}

            <Fade in={props.data?.length <= 0} mountOnEnter unmountOnExit>
                <ListItem alignItems="center">
                    <ListItemText secondary={'No hay notificaciones de este tipo'}/>
                    <Lottie
                        animationData={emptyBoxAnimation}
                        autoplay={true}
                        loop={true}
                        style={{
                            height: 65,
                            width: 65
                        }}
                        speed={1}
                    />
                </ListItem>
            </Fade>

            {/*<ListItemWrapper>*/}
            {/*    <ListItem alignItems="center">*/}
            {/*        <ListItemAvatar>*/}
            {/*            <Avatar alt="John Doe" src={User1}/>*/}
            {/*        </ListItemAvatar>*/}
            {/*        <ListItemText primary="John Doe"/>*/}
            {/*        <ListItemSecondaryAction>*/}
            {/*            <Grid container justifyContent="flex-end">*/}
            {/*                <Grid item xs={12}>*/}
            {/*                    <Typography variant="caption" display="block" gutterBottom>*/}
            {/*                        2 min ago*/}
            {/*                    </Typography>*/}
            {/*                </Grid>*/}
            {/*            </Grid>*/}
            {/*        </ListItemSecondaryAction>*/}
            {/*    </ListItem>*/}
            {/*    <Grid container direction="column" className="list-container">*/}
            {/*        <Grid item xs={12} sx={{pb: 2}}>*/}
            {/*            <Typography variant="subtitle2">It is a long established fact that a reader will be*/}
            {/*                distracted</Typography>*/}
            {/*        </Grid>*/}
            {/*        <Grid item xs={12}>*/}
            {/*            <Grid container>*/}
            {/*                <Grid item>*/}
            {/*                    <Chip label="Unread" sx={chipErrorSX}/>*/}
            {/*                </Grid>*/}
            {/*                <Grid item>*/}
            {/*                    <Chip label="New" sx={chipWarningSX}/>*/}
            {/*                </Grid>*/}
            {/*            </Grid>*/}
            {/*        </Grid>*/}
            {/*    </Grid>*/}
            {/*</ListItemWrapper>*/}
            {/*<Divider/>*/}
            {/*<ListItemWrapper>*/}
            {/*    <ListItem alignItems="center">*/}
            {/*        <ListItemAvatar>*/}
            {/*            <Avatar*/}
            {/*                sx={{*/}
            {/*                    color: theme.palette.success.dark,*/}
            {/*                    backgroundColor: theme.palette.success.light,*/}
            {/*                    border: 'none',*/}
            {/*                    borderColor: theme.palette.success.main*/}
            {/*                }}*/}
            {/*            >*/}
            {/*                <IconBuildingStore stroke={1.5} size="1.3rem"/>*/}
            {/*            </Avatar>*/}
            {/*        </ListItemAvatar>*/}
            {/*        <ListItemText primary={<Typography variant="subtitle1">Store Verification Done</Typography>}/>*/}
            {/*        <ListItemSecondaryAction>*/}
            {/*            <Grid container justifyContent="flex-end">*/}
            {/*                <Grid item xs={12}>*/}
            {/*                    <Typography variant="caption" display="block" gutterBottom>*/}
            {/*                        2 min ago*/}
            {/*                    </Typography>*/}
            {/*                </Grid>*/}
            {/*            </Grid>*/}
            {/*        </ListItemSecondaryAction>*/}
            {/*    </ListItem>*/}
            {/*    <Grid container direction="column" className="list-container">*/}
            {/*        <Grid item xs={12} sx={{pb: 2}}>*/}
            {/*            <Typography variant="subtitle2">We have successfully received your request.</Typography>*/}
            {/*        </Grid>*/}
            {/*        <Grid item xs={12}>*/}
            {/*            <Grid container>*/}
            {/*                <Grid item>*/}
            {/*                    <Chip label="Unread" sx={chipErrorSX}/>*/}
            {/*                </Grid>*/}
            {/*            </Grid>*/}
            {/*        </Grid>*/}
            {/*    </Grid>*/}
            {/*</ListItemWrapper>*/}
            {/* <Divider />
            <ListItemWrapper>
                <ListItem alignItems="center">
                    <ListItemAvatar>
                        <Avatar
                            sx={{
                                color: theme.palette.primary.dark,
                                backgroundColor: theme.palette.primary.light,
                                border: 'none',
                                borderColor: theme.palette.primary.main
                            }}
                        >
                            <IconMailbox stroke={1.5} size="1.3rem" />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<Typography variant="subtitle1">Check Your Mail.</Typography>} />
                    <ListItemSecondaryAction>
                        <Grid container justifyContent="flex-end">
                            <Grid item>
                                <Typography variant="caption" display="block" gutterBottom>
                                    2 min ago
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItemSecondaryAction>
                </ListItem>
                <Grid container direction="column" className="list-container">
                    <Grid item xs={12} sx={{ pb: 2 }}>
                        <Typography variant="subtitle2">All done! Now check your inbox as you&apos;re in for a sweet treat!</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item>
                                <Button variant="contained" disableElevation endIcon={<IconBrandTelegram stroke={1.5} size="1.3rem" />}>
                                    Mail
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItemWrapper>
            <Divider />
            <ListItemWrapper>
                <ListItem alignItems="center">
                    <ListItemAvatar>
                        <Avatar alt="John Doe" src={User1} />
                    </ListItemAvatar>
                    <ListItemText primary={<Typography variant="subtitle1">John Doe</Typography>} />
                    <ListItemSecondaryAction>
                        <Grid container justifyContent="flex-end">
                            <Grid item xs={12}>
                                <Typography variant="caption" display="block" gutterBottom>
                                    2 min ago
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItemSecondaryAction>
                </ListItem>
                <Grid container direction="column" className="list-container">
                    <Grid item xs={12} sx={{ pb: 2 }}>
                        <Typography component="span" variant="subtitle2">
                            Uploaded two file on &nbsp;
                            <Typography component="span" variant="h6">
                                21 Jan 2020
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Card
                                    sx={{
                                        backgroundColor: theme.palette.secondary.light
                                    }}
                                >
                                    <CardContent>
                                        <Grid container direction="column">
                                            <Grid item xs={12}>
                                                <Stack direction="row" spacing={2}>
                                                    <IconPhoto stroke={1.5} size="1.3rem" />
                                                    <Typography variant="subtitle1">demo.jpg</Typography>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItemWrapper>
            <Divider />
            <ListItemWrapper>
                <ListItem alignItems="center">
                    <ListItemAvatar>
                        <Avatar alt="John Doe" src={User1} />
                    </ListItemAvatar>
                    <ListItemText primary={<Typography variant="subtitle1">John Doe</Typography>} />
                    <ListItemSecondaryAction>
                        <Grid container justifyContent="flex-end">
                            <Grid item xs={12}>
                                <Typography variant="caption" display="block" gutterBottom>
                                    2 min ago
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItemSecondaryAction>
                </ListItem>
                <Grid container direction="column" className="list-container">
                    <Grid item xs={12} sx={{ pb: 2 }}>
                        <Typography variant="subtitle2">It is a long established fact that a reader will be distracted</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item>
                                <Chip label="Confirmation of Account." sx={chipSuccessSX} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItemWrapper>*/}
        </List>
    );
};

NotificationList.propTypes = {
    data: PropTypes.array.isRequired,
};

NotificationList.defaultProps = {
    data: [],
};
export default NotificationList;
